import { render, staticRenderFns } from "./FormUpselling.vue?vue&type=template&id=231ee90f&scoped=true"
import script from "./FormUpselling.vue?vue&type=script&setup=true&lang=js"
export * from "./FormUpselling.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormUpselling.vue?vue&type=style&index=0&id=231ee90f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ee90f",
  null
  
)

export default component.exports